export enum CallToActionType {
  ViewRecord = 1,
  EditFormSubmission = 2,
  FormProfile = 3,
  NewFormSubmission = 4,
  ListView = 5,
  File = 6,
  ViewFormSubmission = 7,
}